<template>
    <TPosters v-if="isAppLoaded && canStart">
        <template #map> 
            <router-view />
        </template>
    </TPosters>
</template>

<script>
import {
    mapActions,
    mapGetters
} from "vuex";

import TPosters from '../../templates/t-posters';

export default {
    name: 'PWebIntegration',
    components: {
        TPosters
    },
    computed: {
        ...mapGetters([
            'isAppLoaded',
            'getMapConfigProp'
        ]),
        canStart() {
            const m = window.Modernizr;
            return m && m.webgl && m.webworkers && m.webglextensions
        }
    },
    async mounted() {
        await this.loadMapData();
        const defaultScreenResulution = this.getMapConfigProp(
            'default_screen_resolution', 
            this.getMapConfigProp('components.TPosters.params.default_screen_resolution', 3840)
        );
        document.getElementsByTagName('html')[0].style.fontSize = 100/defaultScreenResulution + 'vw'
    },
    methods: {
        ...mapActions([
            'fetchMapData'
        ]),
        async loadMapData() {
            try {
                const mapId = Number(this.$route.params.mapId);
                await this.fetchMapData(mapId);
            } catch(error) {
                console.log('Data fetch error', error);
            }
        }
    }
}
</script>
